import React from 'react'
import FormatCurrency from '../elements/FormatCurrency'
import DynamicColor from '../common/dynamic-color'
import AmountButton from '../elements/AmountButton'

import { COLOR_NAME } from '../../constants'
import { ensureArray } from '../../utils/helper'
import { getFullFileUrl } from '../../utils/formatData'
import { useTranslation } from 'react-i18next'

import ImgFoodDefault from '../../assets/images/food.png'

const BeilageItem = ({ classesSub, beilage }) => (
    <DynamicColor
        style={{ color: COLOR_NAME.BODY_TEXT_SUB }}
        className="row mt-2"
    >
        <div className={`beilage-name ${classesSub[0] || ''}`}>
            {beilage.name}
        </div>
        <div className={classesSub[1] || ''}>
            <FormatCurrency amount={beilage.price} />
        </div>
    </DynamicColor>
)

const OrderFoodItem = ({ editAble, head, className = '', food }) => {
    const { t } = useTranslation()
    const classes = editAble
        ? [
              'd-flex align-items-center col-4 col-md-5',
              'align-items-center justify-content-center d-none d-md-flex col-1',
              'd-flex align-items-center justify-content-evenly col-3 col-md-3',
              'd-flex heading-6 align-items-center justify-content-end text-right col-3 col-md-2',
              'd-flex align-items-center justify-content-center col-2 col-md-1',
          ]
        : [
              'col-5 col-md-6 d-flex align-items-center',
              'd-none',
              'col-4 col-md-4 d-flex align-items-center justify-content-center',
              'col-3 col-md-2 d-flex align-items-center justify-content-end text-right',
              'd-none',
          ]

    const classesSub = editAble
        ? ['col-7 col-md-9', 'col-3 col-md-2 text-right']
        : ['col-9 col-md-10', ' col-3 col-md-2 text-right']

    if (head) {
        return (
            <DynamicColor
                style={{
                    color: COLOR_NAME.TITLE,
                    backgroundColor: COLOR_NAME.BOX_HEAD_BG,
                }}
                className="row order-food__item-head head label-2"
            >
                <div className={classes[0] || ''}>{t('label.foodInfo')}</div>
                <div className={classes[1] || ''}>{t('label.edit')}</div>
                <div className={classes[2] || ''}>{t('label.amount')}</div>
                <div className={classes[3] || ''}>{t('label.price')}</div>
                <div className={classes[4] || ''}>{t('label.delete')}</div>
            </DynamicColor>
        )
    }

    if (!food) {
        return null
    }

    const { additionFoods } = food

    return (
        <DynamicColor
            style={{
                color: COLOR_NAME.BODY_TEXT,
                borderTopColor: COLOR_NAME.BODY_LINE,
            }}
            className={`order-food__item paragraph-2 ${className}`}
        >
            <div className="row">
                <div className={`order-food__item__name ${classes[0] || ''}`}>
                    <img
                        src={
                            food.imagePath
                                ? getFullFileUrl(food.imagePath)
                                : ImgFoodDefault
                        }
                        alt="food"
                        className="d-none d-lg-block mr-4"
                    />
                    {food.name}
                </div>
                <div className={classes[1] || ''}>
                    <i className="far fa-edit paragraph-1" />
                </div>
                <div className={classes[2] || ''}>
                    {editAble && (
                        <AmountButton
                            onClick={() => {
                                // handleChange('amount', formData.amount - 1)
                            }}
                        />
                    )}

                    <div className="heading-6 px-1">1</div>

                    {editAble && (
                        <AmountButton
                            add
                            onClick={() => {
                                // handleChange('amount', formData.amount - 1)
                            }}
                        />
                    )}
                </div>
                <div className={classes[3] || ''}>
                    <FormatCurrency
                        amount={food.price * food.amount}
                        currency={food.priceUnit}
                    />
                </div>
                <div className={classes[4] || ''}>
                    <i className="fas fa-times" />
                </div>
            </div>

            <div className="order-food__beilage-list">
                {ensureArray(additionFoods).map((beilage, index) => (
                    <BeilageItem
                        classesSub={classesSub}
                        key={index}
                        beilage={beilage}
                    />
                ))}
            </div>
        </DynamicColor>
    )
}

export default OrderFoodItem
